(function (angular) {
  var controllerId = "loginController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "$location", "$window", "alkAuthenticationService", "_", "alkModalService", "ALKLogin", "UserProvider",
      function ($scope, $location, $window, alkAuthenticationService, _, alkModalService, ALKLogin, UserProvider) {
        if ($location.path() === "/login") {$scope.formTab = "login";}
        else if ($location.path() === "/forgot") {$scope.formTab = "forgot";}
        else {$scope.formTab = "signup";}

        if ($location.search().dataVersion)
        {$scope.dataVersion = $location.search().dataVersion;}

        $scope.isIE9 = !_.isUndefined($window.isIE9);
        $scope.isltIE9 = !_.isUndefined($window.isltIE9);

        $scope.canShowForgotPassword = true;
        $scope.canShowForgotPassword = $scope.hideForgotPassword !== "true";
        $scope.userInfo = {};
        $scope.isEmailFocused = true;
        $scope.accounts = [];
        $scope.login = function (userInfo, loginForm, application) {
          $scope.showGenericError = false;
          $scope.showPasswordIncorrect = false;
          $scope.showNoAccountForApplication = false;
          $scope.showAccountDisabled = false;
          $scope.showUserDisabled = false;

          //if ($scope.loginForm.$valid) {
          var login = new ALKLogin(userInfo.username, userInfo.password, userInfo.account);
          if (!login.isBaseValid())
          {return;}

          if ($scope.accounts.length > 0 && !login.isAccountValid())
          {return;}

          $scope.isProcessing = true;
          alkAuthenticationService.login(login).then(() => {
            $scope.loginSuccess();
          },(error) => {

            var failedLogin = true;
            // if username/password was not correct.
            if (error.status !== null && error.status === "FailedToLogin") {
              $scope.showPasswordIncorrect = true;
              //  FIXME:
              //  handle this
            } else if (error.status === "FailedToLoginAccountDisabled") {
              $scope.showAccountDisabled = true;
            }
            else if (error.status === "FailedToLoginUserDisabled") {
              $scope.showUserDisabled = true;
            }
            // if username/password was correct but does not belong to any account.
            else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
              $scope.showNoAccountForApplication = true;
              // if username/password was correct but has one or more accounts. Display the accounts and user can selecte one.
            } else if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
              $scope.accounts = error.accounts;
              $scope.userInfo.account = $scope.accounts[0].accountName;
              loginForm.submitted = false;
              failedLogin = false;
            } else if (error.status !== null && error.status === "FailedToLoginAccountExpired") {
              if(typeof(error.userInfo) !== 'undefined'){
              // if the account expired, we need to get userInfo and redirect user to account page for upgrade.
              alkAuthenticationService
                .getUserInfo(error.userInfo.authToken, error.userInfo.username, error.userInfo.accountName)
                .then((response) => {
                  UserProvider.loadUser(response.user);
                  $scope.loginSuccess();
                }, (err) => {
                  console.log("rejected user info", err);
                });
              }else{
                $scope.showAccountDisabled = true;
              }
            } else {
              //Should handle generic errors, i.e. 500
              $scope.showGenericError = true;
            }

            if (failedLogin) {
              $scope.accounts = [];
              delete $scope.userInfo.account;
            }
            $scope.isProcessing = false;
          });
        };

        $scope.loginSuccess = function () {
          const user = UserProvider.getUser();
          try {
            trackJs.configure({
              userId: `${user.userName} (#${user.userId}), Account ${user.account} (#${user.accountId})`
            });
          } catch (err) {
            console.log("trackJs configure error:", err);
          }

          var gotoPage = $location.search().path || "/app";
          var message;

          // if netSuite is down, temporarily allow user to login and disable billing related features.
          if (!user.netSuiteOnline) {
            $location.url(gotoPage);
          }
          else if (user.hasBillingIssue) {
            message = user.isAdmin() ?
              "There was an error to the credit card on file.  Go to Account Settings and update your card information to continue." :
              "There was an error to the credit card on file.  Please have your company’s administrator go to Account Settings to update your card information.";

            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Billing Issue",
              bodyText: message,
              okOnly: true,
              actionButtonText: user.isAdmin() ? "Update Now" : "OK"
            }).then(() => {
              $location.url("/account");
            });

          }
          else if (typeof user.creditExpiresSoon === "function" && user.creditExpiresSoon() && user.isMonthlyPaidCustomer && !user.isInvoiced) {
            message = user.isAdmin() ?
              `The credit card linked to your account is set to expire on ${  user.getCreditExpiresDate().format("MM/DD/YYYY")  }.  To avoid any disruption in service, please update your card information now.` :
              `The credit card linked to your account is set to expire on ${  user.getCreditExpiresDate().format("MM/DD/YYYY")  }.  To avoid any disruption in service, please have your company’s administrator update the card information.`;

            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Billing Warning",
              bodyText: message,
              okOnly: !user.isAdmin() ||  (user.isMonthlyPaidCustomer && user.checkCreditExpiration()) ,
              closeButtonText: "Later",
              actionButtonText: user.isAdmin() ? "Update Now" : "OK"
            }).then(() => {
              if (user.isAdmin()) {
                $location.url("/account");
              } else {
                $location.url(gotoPage);
              }
            }).catch(() => {
              $location.url(gotoPage);
            });

          }
          else if (user.hasEmptyRecordList) {
            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Subscription Issue",
              bodyTemplate: "/app/modal/emptyResponse.template.html",
              okOnly: true,
              actionButtonText: "OK"
            }).then(() => {
              $scope.isProcessing = false;
              $location.url(gotoPage);
            });
          }
          else {
            $location.url(gotoPage);
          }
        };
        $scope.goToSignup = function () {
          $scope.url = $scope.dataVersion ? `/signupForm?dataVersion=${  $scope.dataVersion}` : "/signupForm";
          $location.url($scope.url);
        };
      }
    ]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/account/login.controller.js